import { useEffect } from 'react';

import { useManualEditStore } from '../job-profile-section/ManualEditStoreProvider';

type UseHasFormChangesOptions = {
    readonly isEditing: boolean;
};

export const useHasFormChanges = ({ isEditing }: UseHasFormChangesOptions): boolean => {
    const hasManualEdits = useManualEditStore((state) => state.hasManualEdits);
    const resetManualEdits = useManualEditStore((state) => state.resetManualEdits);

    useEffect(() => {
        if (!isEditing) {
            resetManualEdits();
        }
    }, [isEditing, resetManualEdits]);

    return isEditing && hasManualEdits;
};
